import React from 'react'
import {
  Button,
  Card,
  Modal,
  Col,
  Form,
  Icon,
  Input,
  Row,
  Switch,
  message,
  notification,
  DatePicker,
  Select,
} from 'antd'
import Moment from 'moment'
import {connect} from 'react-redux'
import {decode} from 'utf8'
import {
  editCouponWithImage, // fetchCoupon
  fetchCoupons,
  fetchCouponsData,
} from 'appRedux/actions/Coupons'
import getDate from 'util/ConfigDates'

const Option = Select.Option

const FormItem = Form.Item

const {TextArea} = Input

class Basic extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      id: '',
      visible: false,
      branchOffice: '',
      category: '',
      ticketName: '',
      description: '',
      loading: false,
      points: 0,
      active: 1,
      imageUrl: '',
      creationDay: getDate('dateFrom'),
      expirationDay: getDate('dateFrom'),
      validateStatusBranchOffice: '',
      helpBrachOffice: '',
      validateStatusTicketName: '',
      helpTicketName: '',
      validateStatusCreation: '',
      helpCreation: '',
      validateStatusPoints: '',
      helpPoints: '',
      validateTarea: '',
      helpTarea: '',
      validateCategory: '',
      helpCategory: '',
    }
  }

  arrayC = () => {
    let array = this.props.placeStores
    return array.map((element, index) => {
      return (
        <Option key={index} value={element.id}>
          {decode(element.name)}
        </Option>
      )
    })
  }

  arrayCat = () => {
    let array = this.props.categories
    return array.map((element, index) => {
      return (
        <Option key={index} value={element.id}>
          {decode(element.name)}
        </Option>
      )
    })
  }

  showModal = () => {
    this.setState({
      active: 1,
      id: this.props.recording.id,
      category: this.props.recording.categoryId,
      visible: true,
      branchOffice: this.props.recording.store_id,
      ticketName: this.props.recording.name,
      description: this.props.recording.description,
      points: this.props.recording.points,
      creationDay: this.props.recording.creationDate,
      expirationDay: this.props.recording.expirationDate || getDate('dateFrom'),
    })
  }

  handleCancel = e => {
    this.setState({
      description: '',
      active: 1,
      points: 0,
      creationDay: getDate('dateFrom'),
    })

    this.props.fetchCouponsData(this.props.dataState)
    this.setState({visible: false})

    if (this.state.branchOffice == '') {
      this.setState({validateStatusBranchOffice: '', helpBrachOffice: ''})
    }
    if (this.state.ticketName == '') {
      this.setState({validateStatusTicketName: '', helpTicketName: ''})
    }
    if (this.state.creationDay == '') {
      this.setState({validateStatusCreation: '', helpCreation: ''})
    }
    if (this.state.points == '') {
      this.setState({validateStatusPoints: '', helpPoints: ''})
    }
    if (this.state.category == '') {
      this.setState({validateCategory: '', helpCategory: ''})
    }
    if (this.state.description == '') {
      this.setState({validateTarea: '', helpTarea: ''})
    }
  }

  onNotification = (type, value) => {
    if (type == 'success') {
      notification[type]({
        message: 'Éxito',
        description: 'El cupón se ha creado con éxito.',
      })
    } else {
      notification[type]({
        message: 'Error',
        description: value || 'Ha ocurrido un error al crear el cupón.',
      })
    }
  }

  onHandleClick = event => {
    event.preventDefault()
    let {branchOffice, ticketName, creationDay, points} = this.state
    if (this.state.validateStatus != 'error') {
      if (branchOffice && ticketName && creationDay && points >= 0) {
        this.props.editCouponWithImage(this.state, () => {
          this.props.fetchCouponsData(this.props.dataState)
        })
        this.onNotification('success')
      } else {
        if (this.state.branchOffice == '') {
          this.setState({
            validateStatusBranchOffice: 'error',
            helpBrachOffice: 'Nombre sucursal es un campo obligatorio.',
          })
        } else {
          this.setState({validateStatusBranchOffice: '', helpBrachOffice: ''})
        }
        if (this.state.ticketName == '') {
          this.setState({
            validateStatusTicketName: 'error',
            helpTicketName: 'Nombre oferta es un campo obligatorio.',
          })
        } else {
          this.setState({validateStatusTicketName: '', helpTicketName: ''})
        }
        if (this.state.points === '') {
          this.setState({
            validateStatusPoints: 'error',
            helpPoints: 'Puntos es un valor obligatorio.',
          })
        } else {
          this.setState({validateStatusPoints: '', helpPoints: ''})
        }
        if (this.state.creationDay == '') {
          this.setState({
            validateStatusCreation: 'error',
            helpCreation: 'Fecha creación es un campo obligatorio.',
          })
        } else {
          this.setState({validateStatusCreation: '', helpCreation: ''})
        }
        if (this.state.description == '') {
          this.setState({
            validateTarea: 'error',
            helpTarea: 'Descripción es un campo obligatorio.',
          })
        } else {
          this.setState({validateTarea: '', helpTarea: ''})
        }
        if (this.state.description == '') {
          this.setState({
            validateCategory: 'error',
            helpCategory: 'Categoría es un campo obligatorio.',
          })
        } else {
          this.setState({validateCategory: '', helpCategory: ''})
        }
      }
    } else {
      this.onNotification('error', 'La contraseña de validación es incorrecta.')
    }
  }

  onChangeCalendar = (date, dateString) => {
    this.setState({creationDay: dateString})
    this.setState({
      validateStatusCreation: '',
      helpCreation: '',
    })
  }

  handleChangeCombo = value => {
    this.setState({
      branchOffice: value,
    })
    this.setState({validateStatusBranchOffice: '', helpBrachOffice: ''})
  }

  handleChangeCategory = value => {
    this.setState({
      category: value,
    })
    this.setState({validateCategory: '', helpCategory: ''})
  }

  handlChangeImage = selectorFiles => {
    const file = selectorFiles[0]
    console.log()
    this.setState({imageUrl: file})
  }

  onChangeCalendarExpiration = (date, dateString) => {
    this.setState({expirationDay: dateString})
  }

  render() {
    // if (!this.props.coupon) {
    //   return <p>Loanding..</p>
    // }
    return (
      <div>
        <Button type="primary" onClick={this.showModal}>
          <i className="icon icon-edit" />
        </Button>
        <Modal
          afterClose={() => this.props.fetchCouponsData(this.props.dataState)}
          okText="Editar"
          cancelText="Salir"
          title=""
          visible={this.state.visible}
          onOk={this.onHandleClick}
          onCancel={this.handleCancel}
        >
          <Card className="gx-card" title="Editar cupón">
            <form onSubmit={this.onHandleClick}>
              <Row>
                <Col lg={12} md={12} sm={12} xs={24}>
                  <FormItem
                    label="Tienda"
                    labelCol={{xs: 12, sm: 8, lg: 8, md: 12}}
                    validateStatus={this.state.validateStatusBranchOffice}
                    help={this.state.helpBrachOffice}
                  >
                    <Select
                      className="gx-mr-3 gx-mb-3"
                      defaultValue={this.state.branchOffice}
                      onChange={this.handleChangeCombo}
                      style={{width: 140}}
                    >
                      {this.arrayC()}
                    </Select>
                  </FormItem>
                </Col>
                <Col lg={12} md={12} sm={12} xs={24}>
                  <FormItem
                    label="Nombre oferta *"
                    labelCol={{xs: 14, sm: 14, lg: 14, md: 14}}
                    validateStatus={this.state.validateStatusTicketName}
                    help={this.state.helpTicketName}
                  >
                    <Input
                      required
                      placeholder="Nombre del cupón"
                      value={this.state.ticketName}
                      onChange={event => {
                        this.setState({
                          ticketName: event.target.value,
                        })
                        if (event.target.value != '') {
                          this.setState({
                            validateStatusTicketName: '',
                            helpTicketName: '',
                          })
                        } else {
                          this.setState({
                            validateStatusTicketName: 'error',
                            helpTicketName:
                              'Nombre de la oferta es un campo obligatorio.',
                          })
                        }
                      }}
                    />
                  </FormItem>
                </Col>

                <Col lg={12} md={12} sm={12} xs={24}>
                  <FormItem
                    label="Fecha creación *:"
                    labelCol={{xs: 14, sm: 14, lg: 14, md: 14}}
                    validateStatus={this.state.validateStatusCreation}
                    help={this.state.helpCreation}
                  >
                    <DatePicker
                      defaultValue={Moment(
                        this.state.creationDay,
                        'YYYY-MM-DD',
                      )}
                      className="gx-mb-3 gx-w-100"
                      onChange={this.onChangeCalendar}
                    />
                  </FormItem>
                </Col>
                <Col lg={12} md={12} sm={12} xs={24}>
                  <FormItem
                    label="Fecha expiración *:"
                    labelCol={{xs: 14, sm: 14, lg: 14, md: 14}}
                  >
                    <DatePicker
                      defaultValue={Moment(
                        this.state.expirationDay,
                        'YYYY-MM-DD',
                      )}
                      className="gx-mb-3 gx-w-100"
                      onChange={this.onChangeCalendarExpiration}
                    />
                  </FormItem>
                </Col>

                <Col lg={12} md={12} sm={12} xs={24}>
                  <FormItem
                    label="Categoría *"
                    labelCol={{xs: 24, sm: 12, lg: 12, md: 21}}
                    validateStatus={this.state.validateStatusCategory}
                    help={this.state.helpCategory}
                  >
                    <Select
                      className="gx-mr-3 gx-mb-3"
                      defaultValue={this.state.category}
                      onChange={this.handleChangeCategory}
                    >
                      {this.arrayCat()}
                    </Select>
                  </FormItem>
                </Col>
                <Col lg={24} md={24} sm={24} xs={24}>
                  <Card type="inner" title="Descripción">
                    <TextArea
                      rows={4}
                      required
                      placeholder="Datos del cupón"
                      value={this.state.description}
                      onChange={event => {
                        this.setState({
                          description: event.target.value,
                        })
                      }}
                    />
                  </Card>
                </Col>
                <Col lg={12} md={12} sm={24} xs={24}>
                  <Card type="inner" title="Valor en puntos">
                    <FormItem
                      labelCol={{xs: 9, sm: 9, lg: 9, md: 9}}
                      validateStatus={this.state.validateStatusPoints}
                      help={this.state.helpPoints}
                    >
                      <Input
                        placeholder="Puntos"
                        value={this.state.points}
                        onChange={event => {
                          if (event.target.value >= 0) {
                            this.setState({
                              points: event.target.value,
                            })
                          }
                          if (
                            event.target.value != '' &&
                            event.target.value >= 0
                          ) {
                            this.setState({
                              validateStatusPoints: '',
                              helpPoints: '',
                            })
                          } else {
                            this.setState({
                              validateStatusPoints: 'error',
                              helpPoints:
                                'Puntos (no letras) es un campo obligatorio.',
                            })
                          }
                        }}
                      />
                    </FormItem>
                  </Card>
                </Col>
                <Col lg={12} md={12} sm={24} xs={24}>
                  <Card type="inner" title="Foto del cupón">
                    <FormItem
                      label="Tamaño: (700 x 450 px)"
                      labelCol={{xs: 24, sm: 24, lg: 24, md: 24}}
                    />
                    <input
                      type="file"
                      onChange={event => {
                        this.handlChangeImage(event.target.files)
                      }}
                    />
                  </Card>
                </Col>
              </Row>
            </form>
          </Card>
        </Modal>
      </div>
    )
  }
}

function mapStateToProps({placeStores, categories}) {
  return {
    placeStores,
    categories,
  }
}

export default connect(
  mapStateToProps,
  {editCouponWithImage, fetchCoupons, fetchCouponsData},
)(Basic)



// WEBPACK FOOTER //
// ./src/routes/main/Cupons/admin/ModalEdit.js